import React, { useEffect, useState } from 'react'
import PackTable from './PackTable'
import { getPacksAPI } from '../../api/pack/packAPI'
import { responseError } from '../../helpers/response/ResponseHelper'

const PackList = () => {

    const [count, setCount] = useState(0)
    const [limit, setLimit] = useState(10)
    const [offset, setOffset] = useState(0)
    const [query, setQuery] = useState('')

    const [packs, setPacks] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    useEffect(() => {
        setLoading(true)
        setError('')
        getPacksAPI({ offset, limit, query }).then(data => {
            setCount(data.count)
            setPacks(data.packs)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }, [limit, offset, query])

  return (
    <div>
        <PackTable
            packs={packs}
            count={count}
            limit={limit}
            setLimit={setLimit}
            offset={offset}
            setOffset={setOffset}
            loading={loading}
        />
    </div>
  )
}

export default PackList